module.exports = __webpack_public_path__ + "img/icon-text.4c220554.svg";